import React from "react";
import { Navigate } from "react-router-dom";

export const PublicRoutes = ({ children, isAuthenticated }) => {
  return !isAuthenticated ? children : <Navigate to="/" />;
};
